'use client';

import { useEffect } from 'react';
import { track } from '@/lib/analytics/track';

/** Fires a product-analytics event once on mount. Drop into any (server) page. */
export default function TrackView({ event, props }: { event: string; props?: Record<string, unknown> }) {
  // biome-ignore lint/correctness/useExhaustiveDependencies: fires once per event name on mount; `props` is an inline object literal from the parent and listing it would re-fire the event every render
  useEffect(() => {
    track(event, props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event]);
  return null;
}
